var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-nav'),_c('side-nav'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-container"},[_c('h3',[_vm._v("Mono2Micro")]),_c('p',[_vm._v("Content coming soon ... ")]),_c('div',{staticClass:"workflow"})])
}]

export { render, staticRenderFns }